
import { useEffect, useState } from "react";
import { Button, Container, OffcanvasBody, OffcanvasHeader } from "reactstrap";
import styles from "./style.module.scss"
import cx from "classnames";
import DefaultOffCanvas, { DefaultOffCanvasProps } from "../DefaultOffCanvas";
import { OpenListPriceGeneratorPubSub, OpenListPriceGeneratorPubSubPayload } from "@utils/pubsubs/PubSub";
import GenerarListPriceForm from "@components/forms/GenerarListPriceForm";

type ListPriceGeneratorOffCanvasProps = {
} & DefaultOffCanvasProps

const ListPriceGeneratorOffCanvas = (props: ListPriceGeneratorOffCanvasProps) => {
    const { btnColor = "primary", className } = props;
    const [isOpen, setOpen] = useState(false);

    useEffect(() => {
        const unsubscribe = OpenListPriceGeneratorPubSub.subscribe(openOffCanvas);
        return () => {
            unsubscribe();
        };
    }, []);

    const openOffCanvas = async (payload: OpenListPriceGeneratorPubSubPayload) => {
        const { openOffCanvas = false } = payload;
        setOpen(openOffCanvas);
    }

    const toogleOffCanvas = (newState: boolean) => {
        setOpen(newState);
        if (newState == false) {
            onCanvasClosed();
        }
    }

    const onCanvasClosed = () => {
        setOpen(false);
    }

    return (
        <>
            {props.children && (<Button
                color={btnColor}
                type="button"
                className={cx([className, styles.button])}
                onClick={() => toogleOffCanvas(!isOpen)}
            >
                {props.children}
            </Button>)}
            <DefaultOffCanvas
                className={styles.offCanvas}
                direction="end"
                isOpen={isOpen}
                onClosed={onCanvasClosed}
                toggle={() => toogleOffCanvas(!isOpen)}
            >
                <OffcanvasHeader className={styles.offCanvasHeader} toggle={onCanvasClosed}>
                    Generar Lista de Precio
                </OffcanvasHeader>
                <OffcanvasBody>
                    <Container>
                        <GenerarListPriceForm />
                    </Container>
                </OffcanvasBody>
            </DefaultOffCanvas >
        </>
    );
}
export default ListPriceGeneratorOffCanvas;
